var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        var _vm$selectedData;
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v(" Last Maintenance - " + _vm._s((_vm$selectedData = _vm.selectedData) === null || _vm$selectedData === void 0 ? void 0 : _vm$selectedData.equipment_name) + " ")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$selectedData2, _vm$selectedData3, _vm$selectedData4, _vm$selectedData5, _vm$selectedData6, _vm$selectedData7, _vm$selectedData8, _vm$selectedData9, _vm$selectedData10, _vm$selectedData$note, _vm$selectedData11, _vm$selectedData12, _vm$selectedData12$jo, _vm$selectedData13, _vm$selectedData13$jo, _vm$selectedData14, _vm$selectedData14$jo, _vm$selectedData14$jo2, _vm$selectedData15, _vm$selectedData15$jo, _vm$selectedData15$jo2, _vm$selectedData16, _vm$selectedData16$jo, _vm$selectedData16$jo2, _vm$selectedData17, _vm$selectedData17$jo, _vm$selectedData$trig, _vm$selectedData18, _vm$selectedData19, _vm$selectedData20, _vm$selectedData21, _vm$selectedData21$jo, _vm$selectedData22;
        return [_c('div', {
          staticClass: "row no-gutters px-2"
        }, [_c('div', {
          staticClass: "col-md-12 pr-md-3 mb-3"
        }, [_c('PmsFleetDetailHeader', {
          attrs: {
            "selectedData": _vm.selectedData
          }
        })], 1), _c('div', {
          staticClass: "col-md-12 mb-3"
        }, [_c('CustomNav', {
          attrs: {
            "items": _vm.leftTabs
          },
          on: {
            "item-click": function itemClick(tab) {
              return _vm.activeTabLeft = tab;
            }
          }
        })], 1), _vm.activeTabLeft == 1 ? _c('div', {
          staticClass: "col-md-12"
        }, [_c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('tbody', [_c('tr', [_c('td', {
          staticClass: "text-muted",
          staticStyle: {
            "width": "30%"
          }
        }, [_vm._v("Status")]), _c('td', [_c('span', {
          staticClass: "badge",
          class: _vm.getStatusBadgeClass((_vm$selectedData2 = _vm.selectedData) === null || _vm$selectedData2 === void 0 ? void 0 : _vm$selectedData2.status)
        }, [_vm._v(" " + _vm._s((_vm$selectedData3 = _vm.selectedData) === null || _vm$selectedData3 === void 0 ? void 0 : _vm$selectedData3.status) + " ")])])]), _c('tr', [_c('td', {
          staticClass: "text-muted"
        }, [_vm._v("Due")]), _c('td', {
          staticClass: "font-semibold text-black"
        }, [_vm.selectedData.triggers == 'CALENDAR' ? [_vm._v(" " + _vm._s(_vm.formatDate(_vm.selectedData.possible_maintenance_date)) + " ")] : [_vm._v(" " + _vm._s(_vm.formatNumber(_vm.selectedData.possible_maintenance_hours) || '0') + " Hours ")]], 2)]), _c('tr', [_c('td', {
          staticClass: "text-muted"
        }, [_vm._v("Last Maintenance Date")]), _c('td', {
          staticClass: "font-semibold text-black"
        }, [_vm._v(" " + _vm._s(_vm.formatDate((_vm$selectedData4 = _vm.selectedData) === null || _vm$selectedData4 === void 0 ? void 0 : _vm$selectedData4.last_maintenance_date)) + " ")])]), (_vm$selectedData5 = _vm.selectedData) !== null && _vm$selectedData5 !== void 0 && _vm$selectedData5.possible_maintenance_hours ? _c('tr', [_c('td', {
          staticClass: "text-muted"
        }, [_vm._v("Plan Maintenance (RH)")]), _c('td', {
          staticClass: "font-semibold text-black"
        }, [_vm._v(" " + _vm._s(_vm.formatHours((_vm$selectedData6 = _vm.selectedData) === null || _vm$selectedData6 === void 0 ? void 0 : _vm$selectedData6.possible_maintenance_hours)) + " Hours ")])]) : _vm._e(), (_vm$selectedData7 = _vm.selectedData) !== null && _vm$selectedData7 !== void 0 && _vm$selectedData7.maintenance_running_hours ? _c('tr', [_c('td', {
          staticClass: "text-muted"
        }, [_vm._v("Actual Maintenance (RH)")]), _c('td', {
          staticClass: "font-semibold text-black"
        }, [_vm._v(" " + _vm._s(_vm.formatHours((_vm$selectedData8 = _vm.selectedData) === null || _vm$selectedData8 === void 0 ? void 0 : _vm$selectedData8.maintenance_running_hours)) + " Hours ")])]) : _vm._e(), _c('tr', [_c('td', {
          staticClass: "text-muted"
        }, [_vm._v("Cost")]), _c('td', {
          staticClass: "font-semibold text-black"
        }, [_vm._v(" " + _vm._s(_vm.formatCurrency((_vm$selectedData9 = _vm.selectedData) === null || _vm$selectedData9 === void 0 ? void 0 : _vm$selectedData9.cost)) + " ")])]), _c('tr', [_c('td', {
          staticClass: "text-muted"
        }, [_vm._v("Attachment")]), _c('td', _vm._l((_vm$selectedData10 = _vm.selectedData) === null || _vm$selectedData10 === void 0 ? void 0 : _vm$selectedData10.attachments, function (file, idx) {
          return _c('b-badge', {
            key: "att-".concat(idx),
            staticClass: "mr-2 cursor-pointer",
            attrs: {
              "variant": "warning",
              "pill": ""
            },
            on: {
              "click": function click($event) {
                return _vm.onPreview(file === null || file === void 0 ? void 0 : file.fileurl);
              }
            }
          }, [_vm._v(" " + _vm._s(file === null || file === void 0 ? void 0 : file.filename) + " "), _c('i', {
            staticClass: "fa fa-download ml-2",
            staticStyle: {
              "font-size": "12px"
            }
          })]);
        }), 1)]), _c('tr', [_c('td', {
          staticClass: "text-muted"
        }, [_vm._v("Notes")]), _c('td', {
          staticClass: "font-semibold text-black"
        }, [_vm._v(" " + _vm._s((_vm$selectedData$note = (_vm$selectedData11 = _vm.selectedData) === null || _vm$selectedData11 === void 0 ? void 0 : _vm$selectedData11.notes) !== null && _vm$selectedData$note !== void 0 ? _vm$selectedData$note : '-') + " ")])])])]), _c('TablePostponed', {
          attrs: {
            "selectedData": _vm.selectedData
          }
        })], 1) : _vm._e(), _vm.activeTabLeft == 2 ? _c('div', {
          staticClass: "col-md-12"
        }, [_c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('tbody', [_c('tr', [_c('td', {
          staticClass: "text-muted",
          staticStyle: {
            "width": "20%"
          }
        }, [_vm._v("Job Code")]), _c('td', {
          staticClass: "font-semibold text-black",
          staticStyle: {
            "width": "30%"
          }
        }, [_vm._v(" " + _vm._s((_vm$selectedData12 = _vm.selectedData) === null || _vm$selectedData12 === void 0 ? void 0 : (_vm$selectedData12$jo = _vm$selectedData12.job_library) === null || _vm$selectedData12$jo === void 0 ? void 0 : _vm$selectedData12$jo.code) + " ")]), _c('td', {
          staticClass: "text-muted",
          staticStyle: {
            "width": "20%"
          }
        }, [_vm._v("Job Name")]), _c('td', {
          staticClass: "font-semibold text-black",
          staticStyle: {
            "width": "30%"
          }
        }, [_vm._v(" " + _vm._s((_vm$selectedData13 = _vm.selectedData) === null || _vm$selectedData13 === void 0 ? void 0 : (_vm$selectedData13$jo = _vm$selectedData13.job_library) === null || _vm$selectedData13$jo === void 0 ? void 0 : _vm$selectedData13$jo.name) + " ")])]), _c('tr', [_c('td', {
          staticClass: "text-muted"
        }, [_vm._v("Equipment Category")]), _c('td', {
          staticClass: "font-semibold text-black text-uppercase"
        }, [_vm._v(" " + _vm._s((_vm$selectedData14 = _vm.selectedData) === null || _vm$selectedData14 === void 0 ? void 0 : (_vm$selectedData14$jo = _vm$selectedData14.job_library) === null || _vm$selectedData14$jo === void 0 ? void 0 : (_vm$selectedData14$jo2 = _vm$selectedData14$jo.maintenance_component) === null || _vm$selectedData14$jo2 === void 0 ? void 0 : _vm$selectedData14$jo2.component_name) + " ")]), _c('td', {
          staticClass: "text-muted"
        }, [_vm._v("Equipment")]), _c('td', {
          staticClass: "font-semibold text-black"
        }, [_vm._v(" " + _vm._s((_vm$selectedData15 = _vm.selectedData) === null || _vm$selectedData15 === void 0 ? void 0 : (_vm$selectedData15$jo = _vm$selectedData15.job_library) === null || _vm$selectedData15$jo === void 0 ? void 0 : (_vm$selectedData15$jo2 = _vm$selectedData15$jo.maintenance_master) === null || _vm$selectedData15$jo2 === void 0 ? void 0 : _vm$selectedData15$jo2.equipment_name) + " ")])]), _c('tr', [_c('td', {
          staticClass: "text-muted"
        }, [_vm._v("Job Type")]), _c('td', {
          staticClass: "font-semibold text-black"
        }, [_vm._v(" " + _vm._s((_vm$selectedData16 = _vm.selectedData) === null || _vm$selectedData16 === void 0 ? void 0 : (_vm$selectedData16$jo = _vm$selectedData16.job_library) === null || _vm$selectedData16$jo === void 0 ? void 0 : (_vm$selectedData16$jo2 = _vm$selectedData16$jo.maintenance_job_type) === null || _vm$selectedData16$jo2 === void 0 ? void 0 : _vm$selectedData16$jo2.job_type_index) + " ")]), _c('td', {
          staticClass: "text-muted"
        }, [_vm._v("Method")]), _c('td', {
          staticClass: "font-semibold text-black"
        }, [_vm._v(" " + _vm._s((_vm$selectedData17 = _vm.selectedData) === null || _vm$selectedData17 === void 0 ? void 0 : (_vm$selectedData17$jo = _vm$selectedData17.job_library) === null || _vm$selectedData17$jo === void 0 ? void 0 : _vm$selectedData17$jo.method) + " ")])]), _c('tr', [_c('td', {
          staticClass: "text-muted"
        }, [_vm._v("Interval")]), _c('td', {
          staticClass: "font-semibold text-black",
          attrs: {
            "colspan": "3"
          }
        }, [_vm.selectedData.triggers == 'COUNTER' ? [_vm._v(" " + _vm._s((_vm$selectedData$trig = (_vm$selectedData18 = _vm.selectedData) === null || _vm$selectedData18 === void 0 ? void 0 : _vm$selectedData18.trigger_interval) !== null && _vm$selectedData$trig !== void 0 ? _vm$selectedData$trig : '0') + " Hours ")] : [_vm._v(" " + _vm._s((_vm$selectedData19 = _vm.selectedData) === null || _vm$selectedData19 === void 0 ? void 0 : _vm$selectedData19.trigger_interval) + " " + _vm._s((_vm$selectedData20 = _vm.selectedData) === null || _vm$selectedData20 === void 0 ? void 0 : _vm$selectedData20.trigger_calendar_type) + " ")]], 2)]), _c('tr', [_c('td', {
          staticClass: "text-muted align-top"
        }, [_vm._v("Job Description")]), _c('td', {
          staticClass: "font-semibold text-black job-description",
          attrs: {
            "colspan": "3"
          },
          domProps: {
            "innerHTML": _vm._s(((_vm$selectedData21 = _vm.selectedData) === null || _vm$selectedData21 === void 0 ? void 0 : (_vm$selectedData21$jo = _vm$selectedData21.job_library) === null || _vm$selectedData21$jo === void 0 ? void 0 : _vm$selectedData21$jo.job_description) || '-')
          }
        })])])])]) : _vm._e(), _vm.activeTabLeft == 3 ? _c('div', {
          staticClass: "col-md-12"
        }, [_c('MaintenanceRhList', {
          attrs: {
            "maintenanceDetailData": {
              vehicle: {
                id: (_vm$selectedData22 = _vm.selectedData) === null || _vm$selectedData22 === void 0 ? void 0 : _vm$selectedData22.vehicle_id
              }
            }
          }
        })], 1) : _vm._e()])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        var _vm$selectedData23;
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v(" Process Maintenance - " + _vm._s((_vm$selectedData23 = _vm.selectedData) === null || _vm$selectedData23 === void 0 ? void 0 : _vm$selectedData23.equipment_name) + " ")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$selectedData24, _vm$selectedData25, _vm$selectedData26, _vm$selectedData27, _vm$selectedData28;
        return [_c('div', {
          staticClass: "mb-3 text-primary"
        }, [_c('strong', [_vm._v(" " + _vm._s((_vm$selectedData24 = _vm.selectedData) === null || _vm$selectedData24 === void 0 ? void 0 : _vm$selectedData24.power_type_name) + " - " + _vm._s((_vm$selectedData25 = _vm.selectedData) === null || _vm$selectedData25 === void 0 ? void 0 : _vm$selectedData25.power_series_name) + " " + _vm._s((_vm$selectedData26 = _vm.selectedData) === null || _vm$selectedData26 === void 0 ? void 0 : _vm$selectedData26.power_series_model) + " ")])]), _c('CustomNav', {
          staticClass: "mb-3",
          attrs: {
            "items": _vm.rightTabs
          },
          on: {
            "item-click": function itemClick(tab) {
              return _vm.activeTabRight = tab;
            }
          }
        }), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.activeTabRight == 1,
            expression: "activeTabRight == 1"
          }]
        }, [_c('FormMaintenanceProcessSingle', {
          attrs: {
            "methodType": (_vm$selectedData27 = _vm.selectedData) === null || _vm$selectedData27 === void 0 ? void 0 : _vm$selectedData27.triggers,
            "selectedData": _vm.selectedData,
            "isEditMode": _vm.isEditMode
          },
          on: {
            "refetch": function refetch($event) {
              return _vm.$emit('refetch');
            },
            "close": function close($event) {
              return _vm.$emit('close');
            }
          }
        })], 1), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.activeTabRight == 2,
            expression: "activeTabRight == 2"
          }]
        }, [_c('MaintenanceCommentFormNew', {
          attrs: {
            "selectedData": _vm.selectedData
          }
        })], 1), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.activeTabRight == 3,
            expression: "activeTabRight == 3"
          }]
        }, [_c('MaintenanceLogs', {
          attrs: {
            "logs": (_vm$selectedData28 = _vm.selectedData) === null || _vm$selectedData28 === void 0 ? void 0 : _vm$selectedData28.logs.map(function (log) {
              var _log$user;
              return {
                name: (log === null || log === void 0 ? void 0 : (_log$user = log.user) === null || _log$user === void 0 ? void 0 : _log$user.username) || '-',
                date: log.created_date,
                description: "Changed Status to ".concat(log.status)
              };
            })
          }
        })], 1)];
      },
      proxy: true
    }])
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }